
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wedding-ideas-blog",
      function () {
        return require("private-next-pages/wedding-ideas-blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wedding-ideas-blog"])
      });
    }
  